module.exports = __webpack_public_path__ + "img/大同市海域房地产开发有限责任公司.765786db.png";